window.QformGroupTeams = {};

QformGroupTeams.init = function() {
  $('.teams-select').on('change', function () {
    let selected_values = $(this).find('option:selected').toArray().map(item => item.value);
    let select_for_change = (this.id == 'qform_group_team_ids_write') ? 'read_only' : 'write'
    let options = $(this).closest(".qform-group-teams").find(`#qform_group_team_ids_${select_for_change}`)[0].options

    if (selected_values) {
      hideSelectedOptionsTeams(options, selected_values)
    }
  });

  $('.qform-group-teams select').trigger('change');

  $('.qform-group-teams-dropdown .dropdown-menu').click(function(e) {
    e.stopPropagation()
  })
}

function hideSelectedOptionsTeams(options, selected) {
  $(options).each(function(i, option) {
    $(option).removeClass('hidden')

    if (selected.includes(option.value)) {
      $(option).addClass('hidden')
    }
  })
}
